import {connect} from 'react-redux';
import QBEHazards from 'app/components/RightBarPane/Property/QBEHazards';
import {convertPrimitiveListToArray} from 'app/shared/utils';

export const mapStateToProps = (state) => ({
    hazards: convertPrimitiveListToArray(state.getIn(['property', 'selectedProperty', 'qbeHazards'])),
});

export default connect(mapStateToProps)(QBEHazards);